export const familyPl = {
  family: {
    nav: {
      title: 'Rodzina',
    },
    page: {
      title: 'Rodzina',
      subtitle: 'Zarządzaj rodziną, członkami i zaproszeniami',
    },
    onboarding: {
      title: 'Załóż rodzinę',
      description: 'Rodzina pozwala współdzielić listy zakupów i przepisy. Zostaniesz jej właścicielem.',
      nameLabel: 'Nazwa rodziny',
      namePlaceholder: 'np. Kowalscy',
      submit: 'Załóż rodzinę',
    },
    card: {
      title: 'Rodzina',
      plan: 'Plan',
      members: 'Członkowie',
      memberLimit: 'Limit członków',
      unlimited: 'Bez limitu',
    },
    plans: {
      free: 'Darmowy',
      basic: 'Basic',
      pro: 'Pro',
    },
    roles: {
      owner: 'Właściciel',
      member: 'Członek',
    },
    members: {
      title: 'Członkowie',
      description: 'Osoby współdzielące tę rodzinę',
      name: 'Imię',
      email: 'E-mail',
      role: 'Rola',
      joinedAt: 'Dołączył(a)',
      remove: 'Usuń',
      empty: 'Brak członków',
      you: 'Ty',
    },
    invitations: {
      title: 'Zaproszenia',
      description: 'Udostępnij link, aby zaprosić kogoś do rodziny',
      create: 'Utwórz link zaproszenia',
      limitReached: 'Osiągnięto limit członków dla Twojego planu',
      copy: 'Kopiuj link',
      copied: 'Link skopiowany do schowka',
      expiresAt: 'Wygasa',
      never: 'Nigdy',
      empty: 'Brak aktywnych zaproszeń',
      banner: {
        title: 'Zaproszenie do rodziny',
        loading: 'Sprawdzanie zaproszenia…',
        description: 'Zostałeś zaproszony do rodziny „{name}". Zaloguj się, aby zobaczyć zaproszenie i dołączyć.',
      },
    },
    accept: {
      title: 'Dołącz do rodziny',
      description: 'Otrzymałeś zaproszenie do rodziny.',
      descriptionWithName: 'Zostałeś zaproszony do rodziny „{name}".',
      joining: 'Dołączanie…',
      accept: 'Przyjmij zaproszenie',
      decline: 'Nie teraz',
      success: 'Dołączyłeś do rodziny',
      goToFamily: 'Przejdź do rodziny',
      errorTitle: 'Nie udało się dołączyć',
      errors: {
        notFound: 'Ten link zaproszenia jest nieprawidłowy.',
        expired: 'Ten link zaproszenia wygasł.',
        alreadyAccepted: 'To zaproszenie zostało już wykorzystane.',
        alreadyInFamily: 'Jesteś już członkiem rodziny.',
        limitReached: 'Rodzina osiągnęła limit członków.',
        generic: 'Coś poszło nie tak podczas dołączania do rodziny.',
      },
    },
    toasts: {
      created: 'Rodzina utworzona',
      createError: 'Nie udało się utworzyć rodziny',
      invitationCreated: 'Link zaproszenia utworzony',
      invitationError: 'Nie udało się utworzyć zaproszenia',
      memberLimitReached: 'Osiągnięto limit członków dla Twojego planu',
      memberRemoved: 'Członek usunięty',
      removeMemberError: 'Nie udało się usunąć członka',
    },
  },
}
